import { type OnInit, Component, EventEmitter, Injector, Input, Output } from '@angular/core';
import { type ColumnDef, type TableConfig, TableAbstract, UNPLACEHOLDER } from '@dm/core';

import { WindowsAccessUserGroupStrService } from '../windows-local-access-user-group-str.service';
import { type Privilege } from './permit-table';

@Component({
    selector: 'app-windows-local-access-group-permit-table',
    templateUrl: './permit-table.component.html',
    styleUrls: ['./permit-table.component.scss'],
})
export class PermitTableComponent extends TableAbstract<Privilege> implements OnInit {
    @Input() initData: Privilege[] = [];
    @Input() selectData: Privilege[] = [];
    @Input() isEdit = true;
    /**
     * 已选项的双向绑定实现，每一次改变值，都要emit出去
     */
    @Output() selectDataChange: EventEmitter<Privilege[]> = new EventEmitter();

    i18n = this.str.i18n;

    tableConfig: TableConfig;
    tableColumnDefs: ColumnDef[];

    constructor(
        public str: WindowsAccessUserGroupStrService,
        injector: Injector,
    ) {
        super(injector);
    }

    initTable(): void {
        this.tableConfig = {
            dataKey: 'key',
            selectionMode: this.isEdit ? 'checkbox' : undefined,
            filterLabel: false,
            rows: null,
            menuItems: [
            ],
        };

        this.tableColumnDefs = [
            {
                field: 'key',
                header: this.i18n.name,
            },
            {
                field: 'description',
                header: this.i18n.description,
                render: (value) => value || UNPLACEHOLDER,
            },
        ];
    }

    initBtns(): void {
        return;
    }

    onSelectDataChange(selectData: Privilege[]): void {
        this.selectDataChange.emit(selectData);
    }
}
